import { HistoryDetailsProps } from "./types";
import { HISTORY_OPERATION_TYPE } from "@letsbit/malcolmlb";
import { HistoryDetailsDeposit } from "./components/HistoryDetailsDeposit";
import { HistoryDetailsWithdraw } from "./components/HistoryDetailsWithdraw";
import { HistoryDetailsAdjustment } from "./components/HistoryDetailsAdjustment";
import { HistoryDetailsAutoswap } from "./components/HistoryDetailsAutoswap";
import { HistoryDetailsCardTransactions } from "./components/HistoryDetailsCardTransactions";
import { HistoryDetailsInterest } from "./components/HistoryDetailsInterest";
import { HistoryDetailsPaymentService } from "./components/HistoryDetailsPaymentService";
import { HistoryDetailsReferrerPayout } from "./components/HistoryDetailsReferrerPayout";
import { HistoryDetailsReward } from "./components/HistoryDetailsReward";
import { HistoryDetailsTrade } from "./components/HistoryDetailsTrade";
import { HistoryDetailsPaymentsWithholding } from "./components/HistoryDetailsWithholding";
import { HistoryDetailsWithholdingsWithholding } from "./components/HistoryDetailsWithholdingsWithholding";
import { HistoryDetailsMerkAccount } from "./components/HistoryDetailsMerkAccount";
import { BackButton } from "components/BackButton";
import { Drawer } from "antd";

export const HistoryDetails: React.FC<HistoryDetailsProps> = ({
  data,
  onClose,
}) => {
  return (
    <Drawer
      width="33%"
      placement="right"
      keyboard={true}
      closable={false}
      onClose={onClose}
      open={!!data}
      getContainer=".ion-root"
    >
      <div className="flex flex-col gap-y-6">
        <BackButton onClick={onClose} />
        {data?.type === HISTORY_OPERATION_TYPE.DEPOSIT && (
          <HistoryDetailsDeposit data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.WITHDRAW && (
          <HistoryDetailsWithdraw data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.ADJUSTMENT && (
          <HistoryDetailsAdjustment data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.AUTOSWAP && (
          <HistoryDetailsAutoswap data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.CARD_TRANSACTIONS && (
          <HistoryDetailsCardTransactions data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.INTEREST_PAYMENT && (
          <HistoryDetailsInterest data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.PAYMENT && (
          <HistoryDetailsPaymentService data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.REFERRER_PAYOUT && (
          <HistoryDetailsReferrerPayout data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.REWARD && (
          <HistoryDetailsReward data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.TRADE && (
          <HistoryDetailsTrade data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.WITHHOLDING && (
          <HistoryDetailsPaymentsWithholding data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.WITHHOLDINGS_WITHHOLDING && (
          <HistoryDetailsWithholdingsWithholding data={data} />
        )}
        {data?.type === HISTORY_OPERATION_TYPE.MERK_ACCOUNT_MOVEMENT && (
          <HistoryDetailsMerkAccount data={data} />
        )}
      </div>
    </Drawer>
  );
};
